<ng-container *ngFor="let data of paygroups; last as last">
	<app-list-item [payGroup]="data" (click)="selectPaygroup(data)"></app-list-item>

	<mat-divider class="paygroup-divider" *ngIf="!last"></mat-divider>
</ng-container>
